export default __webpack_public_path__ + "static/media/piwigo.0cb0e2d6.png";